/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index skeleton to autogenerate all the components and extensions
 * Used by "prepareSkeletons"
 */

import Skeleton from './skeleton/Skeleton'
export * from './skeleton/Skeleton'
export default Skeleton
